import { ActionReducerMap } from '@ngrx/store';

import * as auth from './reducers/auth.reducers';
import * as customers from './reducers/customer.reducers';
import * as domain from './reducers/domain.reducers';
import * as riskAssessments from './reducers/risk-assessment.reducers';
import * as admin from './reducers/admin.reducers';
import * as ownRestrictedList from './reducers/own-restricted-list.reducers';
import * as record from './reducers/record.reducers';
import * as pusher from './reducers/pusher.reducers';
import * as document from './reducers/document.reducers';

import * as AuthActions from './actions/auth.actions';
import * as customerActions from './actions/customer.actions';
import * as domainActions from './actions/domain.actions';
import * as riskAssessmentActions from './actions/risk-assessment.actions';
import * as adminAction from './actions/admin.actions';
import * as ownRestrictedListActions from './actions/own-restricted-list.actions';
import * as recordAction from './actions/record.action';
import * as search from './reducers/search.reducers';
import * as searchActions from './actions/search.actions';
import * as error from './reducers/error.reducers';
import * as errorActions from './actions/error.actions';
import * as userPreference from './reducers/user-preference.reducers';
import * as userPreferenceActions from './actions/user-preference.actions';
import * as billable from './reducers/billable.reducers';
import * as billableActions from './actions/billable.actions';
import * as pusherActions from './actions/pusher.actions';
import * as documentActions from './actions/document.actions';

export interface AppState {
  auth: auth.State;
  customer: customers.State;
  domain: domain.State;
  riskAssessment: riskAssessments.State;
  admin: admin.State;
  ownRestrictedList: ownRestrictedList.State;
  record: record.State;
  search: search.State;
  error: error.State;
  userPreference: userPreference.State;
  billable: billable.State;
  pusher: pusher.State;
  document: document.State;
}

export const Reducers: ActionReducerMap<AppState, any> = {
  auth: auth.Reducer,
  customer: customers.reducer,
  domain: domain.reducer,
  riskAssessment: riskAssessments.reducer,
  admin: admin.reducer,
  ownRestrictedList: ownRestrictedList.reducer,
  record: record.reducer,
  search: search.reducer,
  error: error.reducer,
  userPreference: userPreference.reducer,
  billable: billable.reducer,
  pusher: pusher.reducer,
  document: document.reducer
};

export const Selectors = {
  auth: auth.Selectors,
  customer: customers.Selectors,
  domain: domain.Selectors,
  riskAssessment: riskAssessments.Selectors,
  admin: admin.Selectors,
  ownRestrictedList: ownRestrictedList.Selectors,
  record: record.Selectors,
  search: search.Selectors,
  error: error.Selectors,
  userPreference: userPreference.Selectors,
  billable: billable.Selectors,
  pusher: pusher.Selectors,
  document: document.Selectors
};

export const Actions = {
  auth: AuthActions,
  customer: customerActions,
  domain: domainActions,
  riskAssessment: riskAssessmentActions,
  admin: adminAction,
  ownRestrictedList: ownRestrictedListActions,
  record: recordAction,
  search: searchActions,
  error: errorActions,
  userPreference: userPreferenceActions,
  billable: billableActions,
  pusher: pusherActions,
  document: documentActions
};

